import { Id, Json, JsonEntity } from '@homeleite/arch';
import { EMPTY } from '@homeleite/common-utils';
import { CompanyStatus } from './company-status';

export class CompanySummary implements JsonEntity {
    constructor(
      public readonly id = Id.gen(),
      public readonly apcId = EMPTY,
      public name = EMPTY,
    ) { }

    toJson() {
      return Json.to.simple(this);
    }

    static fromJson(json: any): CompanySummary {
        return json ? Json.from.simple(json, CompanySummary) : null;
    }
}

export class Company implements JsonEntity {
    constructor(
        public readonly id = Id.gen(),
        public name = EMPTY,
        public status: CompanyStatus = null,
    ) { }

    toJson() {
        return Json.to.simple(this);
    }

    static fromJson(json: any): Company {
        return json ? Json.from.simple(json, Company) : null;
    }
}
